import { createContext } from '@lit/context';

export const editModeContext = createContext<boolean>(Symbol('edit-mode'));